import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from "recharts";
import { InfoHint } from "./InfoHint";
import { Clock } from "@phosphor-icons/react";

const recColor = (v) => (v >= 67 ? "#00e676" : v >= 34 ? "#ffea00" : "#ff3b30");

export default function SleepWindowCard({ windowData }) {
  if (!windowData) return null;
  const { bins, best } = windowData;
  return (
    <div className="glass-card p-5" data-testid="sleep-window-card">
      <div className="flex items-center gap-2 mb-1">
        <Clock size={18} weight="fill" className="text-[#a970ff]" />
        <h3 className="text-sm font-semibold">Оптимальное окно отбоя<InfoHint text="Рекомендуемое время отбоя, при котором вы исторически получаете лучшее восстановление и качество сна." /></h3>
      </div>
      <p className="text-xs text-muted-foreground mb-4">
        Ваше золотое окно — около <span className="text-[#00e676] font-semibold num">{best.label}</span>: среднее восстановление <span className="num font-semibold text-foreground">{best.avg}%</span> ({best.n} ночей). Среднее восстановление по каждому времени отбоя из вашей истории.
      </p>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={bins}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(220 10% 16%)" vertical={false} />
          <XAxis dataKey="label" stroke="hsl(220 10% 40%)" fontSize={11} tickLine={false} axisLine={false} />
          <YAxis domain={[0, 100]} stroke="hsl(220 10% 40%)" fontSize={11} tickLine={false} axisLine={false} width={30} />
          <Tooltip contentStyle={{ background: "hsl(220 10% 12%)", border: "1px solid hsl(220 10% 22%)", borderRadius: 8, fontSize: 12 }}
            formatter={(v, n, p) => [`${v}% (${p.payload.n} ночей)`, "Ср. восстановление"]} />
          <Bar dataKey="avg" radius={[3, 3, 0, 0]}>
            {bins.map((b, i) => <Cell key={i} fill={recColor(b.avg)} fillOpacity={b.label === best.label ? 1 : 0.55} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
